import {Component, ElementRef, EventEmitter, HostBinding, Input, Output, Renderer2} from '@angular/core';
import {OPTION_ITEM} from '../../services/option/option.service';
import {OPTION_TYPE} from '../../defines/client.const';
import {SetHtmlLargeMode} from '../../defines/client.func';
import {GlobalEventService} from "../../services/global-event/global-event.service";

@Component({
  selector: 'app-option-item',
  templateUrl: './option-item.component.html',
  styleUrls: ['./option-item.component.scss']
})
export class OptionItemComponent {
  // @HostBinding('attr.class') cssClass = 'item-box';
  @Input() optionItem: OPTION_ITEM | null = null;
  @Input() closeBtn = false;
  @Output() close: EventEmitter<any>;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    this.close = new EventEmitter<any>();
  }

  public SetOptionValue(option: OPTION_ITEM, value: any): void {
    option.setter(value);

    // 옵션 타입이 LARGE_MODE 일 경우에만 처리합니다.
    if (option.type === OPTION_TYPE.LARGE_MODE) {
      SetHtmlLargeMode(this.renderer, this.el, value);
    }
  }

  protected onClose($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    this.close.emit();
  }
}
